import { type FC } from 'preact/compat';

import { useIntl } from '@/app/lib/localization/hooks/use-intl';

import { useUserProfile } from '@/shared/stores/app-store/app-store';

import noAdImage from '../assets/no-ad.png';
import tgStarImage from '../assets/tg-star.png';
import { useNoAdPurchase } from '../model/use-no-ad-purchase';

import s from './index.module.scss';

export const NoAdPurchase: FC = () => {
  const t = useIntl();
  const userProfile = useUserProfile();
  const { status, prize, isPurchasing, isInProcess, purchase } = useNoAdPurchase();

  // Юзер уже купил отключение рекламы.
  if (userProfile?.tests?.noAd) return null;

  // Не удалось получить инфу о товаре — не показываем плашку.
  if (status === 'error') return null;

  const isLoading = status === 'loading';
  const price = prize?.price.value ?? null;

  return (
    <div className={s.plate}>
      <img className={s.icon} src={noAdImage} alt="" />
      <div className={s.text}>
        <span className={s.title}>{t('No ads')}</span>
        <span className={s.subtitle}>{t('Disable ads in all daily games forever')}</span>
      </div>

      {isInProcess ? (
        <span className={s['in-process']}>{t('In process')}</span>
      ) : (
        <button
          className={s['buy-button']}
          onClick={purchase}
          disabled={isLoading || isPurchasing}
        >
          <span className={s['buy-top']}>{t('Buy')}</span>
          <span className={s['buy-bottom']}>
            <img className={s.star} src={tgStarImage} alt="" />
            {isLoading ? <span className={s.skeleton} /> : price}
          </span>
        </button>
      )}
    </div>
  );
};
